import client from '@/api/managerApi';

export default {
    getLogInfo({ group, id }) {
        return client.get(`/applog/${group}/${id}`);
    }
};
